import React, { useEffect, useState } from 'react';
import { dialogConfigs } from '../Utils/PMHelper';
import { CustomDialog } from '../Components/CustomDialog';
import { TParty, TPartyType } from '../Types/party.types';
import { toast } from 'react-toastify';

import ServiceWrapper from 'Services/ServiceWrapper';
import AuthManager from 'Common/AuthManager';
import AppSettings from 'Settings/AppSettings';

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

type CreatePartyDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: any) => void;
    isLoading?: boolean;
    editData?: TParty | null;
    mode?: 'create' | 'edit';
}

export const CreatePartyDialog = ({ isOpen, onClose, onSave, isLoading = false,editData = null,mode = 'create' }: CreatePartyDialogProps) => {
    const [partyTypes, setPartyTypes] = useState<TPartyType[]>([]);
    const [isFetchingTypes, setIsFetchingTypes] = useState(false);
    
    useEffect(() => {
        if (isOpen) {
            fetchPartyTypes();
        }
    }, [isOpen]);
    
    const fetchPartyTypes = async () => {
        setIsFetchingTypes(true);
        try {
            const partyTypeResponse = await ServiceWrapper.doGet( `${api_base_url}partytype/list`, null, null, AuthManager.getGmsToken(),); 
            const response = partyTypeResponse?.data;
            if (response && response.done && response.data) {
                setPartyTypes(response.data);
            } else {
                toast.error('Failed to load party types');
            }
        } catch (error) {
            console.error('Error fetching party types:', error);
            toast.error('Error loading party types');
        } finally {
            setIsFetchingTypes(false);
        }
    };
    
    const getFields = () => {
        const baseFields = [...dialogConfigs.createParty.fields];
        
        const updatedFields = baseFields.map(field => {
            if (field.name === 'partyType') {
                return {
                    ...field,
                    options: partyTypes.map(type => ({
                        value: type.name,
                        label: type.name
                    }))
                };
            }
            return field;
        });
        
        if (mode === 'edit' && editData) {
            return updatedFields.map(field => {
                switch (field.name) {
                    case 'partyName':
                        return { ...field, defaultValue: editData.name };
                    case 'partyType':
                        return { ...field, defaultValue: editData.party_type || '' };
                    case 'address':
                        return { ...field, defaultValue: editData.address || '' };
                    default:
                        return field;
                }
            });
        }
        
        return updatedFields;
    };

    const handleSave = (formData: any) => {
        if (mode === 'edit' && editData) {
            const editPayload = {
                name: formData.partyName,
                address: formData.address,
                party_type: formData.partyType,
                active: editData.active, 
                sams_id: editData.sams_id
            };
            onSave(editPayload);
        } else {
            onSave(formData);
        }
    };

    return (
        <CustomDialog      
            isOpen={isOpen}
            onClose={onClose}
            title={mode === 'edit' ? 'Edit Party' : dialogConfigs.createParty.title}
            fields={getFields()}
            onSave={handleSave}
            saveButtonText={mode === 'edit' ? 'Update' : 'Create'}
            isLoading={isLoading || isFetchingTypes}
        />
    );
};